import { DataProcessingLink as SBankDataProtectionLink } from '@ui-common/components/DataProcessingLink'
import { EntranceDataProtection as CommonDataProtection } from '@ui-common/components/EntranceDataProtection'
import { ExternalLink } from '@ui-components/actions/ExternalLink'
import { JSX, ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

const SGroupDataProtectionLink = (msg: ReactNode[]): JSX.Element => {
  const { formatMessage } = useIntl()
  return (
    <ExternalLink key={'s-group-data-protection-link'} href={formatMessage({ id: 's-group-data-protection-link-url' })}>
      {msg}
    </ExternalLink>
  )
}

export const DataProtection = (): JSX.Element => (
  <CommonDataProtection>
    <FormattedMessage
      id="digila-entrance-data-protection-statements"
      values={{
        sBankLink: SBankDataProtectionLink,
        sGroupLink: SGroupDataProtectionLink,
      }}
    />
  </CommonDataProtection>
)
